import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// https://router.vuejs.org/guide/advanced/lazy-loading.html#lazy-loading-routes
// setting the imports outside the route
const Global = () =>
  import(/* webpackChunkName: "global" */ "@/views/Global.vue");
const ESHealth = () =>
  import(/* webpackChunkName: "es-health" */ "@/views/ESHealth.vue");
const GCISearch = () =>
  import(/* webpackChunkName: "gci-search" */ "@/views/GCISearch.vue");
const GCIBrowse = () =>
  import(/* webpackChunkName: "gci-browse" */ "@/views/GCIBrowse.vue");
const GCIBrowseResults = () =>
  import(/* webpackChunkName: "gci-browse" */ "@/views/GCIBrowseResults.vue");
const GCIPub = () =>
  import(/* webpackChunkName: "gci-pub" */ "@/views/GCIPub.vue");
const GCIPubResults = () =>
  import(/* webpackChunkName: "gci-pub" */ "@/views/GCIPubResults.vue");
const MuseumEd = () =>
  import(/* webpackChunkName: "museum-ed" */ "@/views/MuseumEd.vue");
const MuseumEdResults = () =>
  import(/* webpackChunkName: "museum-ed" */ "@/views/MuseumEdResults.vue");
const VirtualLibrary = () =>
  import(/* webpackChunkName: "virtuallibrary" */ "@/views/VirtLib.vue");
const VirtualLibraryResults = () =>
  import(/* webpackChunkName: "virtuallibrary" */ "@/views/VirtLibResults.vue");
const KIM = () => import(/* webpackChunkName: "kim" */ "@/views/KIM.vue");

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "global",
      component: Global
    },
    {
      path: "/global",
      redirect: {
        name: "global"
      }
    },
    {
      path: "/health/elasticsearch",
      name: "eshealth",
      component: ESHealth
    },
    {
      path: "/gci",
      name: "gci",
      component: GCISearch
    },
    {
      path: "/gci/browse",
      name: "gcibrowse",
      component: GCIBrowse
    },
    {
      path: "/gci/browseresults",
      name: "gcibrowseresults",
      component: GCIBrowseResults
    },
    {
      path: "/gci/options",
      name: "gcioptions",
      redirect: {
        name: "gci"
      }
    },
    {
      path: "/gci/results",
      name: "gciresults",
      redirect: {
        name: "gci"
      }
    },
    {
      path: "/kim",
      name: "kim",
      component: KIM
    },
    {
      path: "/museumed",
      name: "museumed",
      component: MuseumEd
    },
    {
      path: "/museumed/results",
      name: "museumedresults",
      component: MuseumEdResults
    },
    {
      path: "/publications",
      name: "gcipub",
      component: GCIPub
    },
    {
      path: "/publications/resultslist",
      name: "gcipublist",
      component: GCIPubResults
    },
    {
      path: "/publications/resultstiles",
      name: "gcipubtiles",
      component: GCIPubResults
    },
    {
      path: "/virtuallibrary",
      name: "virtuallibrary",
      component: VirtualLibrary
    },
    {
      path: "/virtuallibrary/VirtualLibrary",
      name: "virtuallibraryresults",
      component: VirtualLibraryResults
    }
  ]
});
